import * as React from "react";

export const IconSortList = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_24511_15601)">
      <path
        d="M7.49935 3L4.16602 6.325H6.66602L6.66602 12.1667H8.33268L8.33268 6.325H10.8327L7.49935 3ZM13.3327 14.675V8.83333L11.666 8.83333L11.666 14.675L9.16602 14.675L12.4993 18L15.8327 14.675H13.3327Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_24511_15601">
        <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);
